import React, {Component} from 'react';
import {connect} from 'react-redux';
import { Trans} from 'react-i18next';


import './VoteStatus.css';

class VoteStatus extends Component {

    constructor(props) {

        super(props);
        this.state = {}
    }

    render() {

        const currentRound = this.props.competition.currentRound;
        if(!currentRound) {
            return null;
        }

        return (
            <div className={`vote-status`}>
                <div className={currentRound && currentRound.voteOpen ? 'open' : 'closed'}>
                    {currentRound && currentRound.voteOpen ?  <Trans i18nKey="now_open" /> : <Trans i18nKey="now_closed" />}!
                </div>
            </div>
        );
    }
}

//-------------------------------------------------------------------------
//-------------------- Mapping store to App's props ----------------------
//-------------------------------------------------------------------------

const mapStateToProps = (state, ownProps) => {

    const things = state.default;
    return {
        ...ownProps,
        competition: things.competition,
        auth: things.auth,
        locale: things.locale
    }
}

const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(VoteStatus);



// WEBPACK FOOTER //
// ./src/views/components/VoteStatus.js